import { global } from "../../constants";

export const data = {
  banner: {
    base: "Servicios",
    background: global.banner + "tax-law.webp",
    title: "Derecho Tributario",
    crumb: "Derecho Tributario",
  },
  icon: "fa-solid fa-scale-balanced",
  shortDescription:
    "Asesoría fiscal integral para empresas marítimas, portuarias y de comercio exterior: optimización tributaria, incentivos y cumplimiento formal.",

  title: "Derecho Tributario",
  features: {
    title: "Derecho Tributario",
    deliverables: "Entregables",
    reqDocuments: "Documentos Requeridos",
    subtitle:
      "Análisis estratégico de obligaciones fiscales, incentivos y planificación aduanera para el sector marítimo y logístico.",
    description: `Asesoría fiscal especializada en ISLR, IVA, contribuciones parafiscales y seguridad social aplicables al sector marítimo y portuario. Evaluamos modelo de negocio, ubicación operativa (zonas francas / ZEE), obligaciones formales, incentivos y esquemas internacionales cuando corresponda, diseñando un plan de cumplimiento y optimización fiscal adaptado al riesgo operativo y regulatorio.`,
    viewDetail: "Ver Detalles",
    feats: [
      {
        key: "actividad",
        title: "Identificación del tipo de actividad económica y modelo de negocio",
        summary:
          "Clasificamos la actividad (transporte marítimo, agencia, estiba, logística, servicios offshore) para determinar el tratamiento tributario aplicable.",
        details:
          "Realizamos un diagnóstico del modelo de negocio para identificar la naturaleza de la renta y su encuadramiento fiscal: actividades sujetas a tributación por ISLR, operaciones gravadas por IVA o exentas, tratamiento de ingresos por fletes, comisiones y servicios conexos. Este análisis es la base para definir régimen tributario, obligaciones de retención y formalidades contables.",
        deliverables: [
          "Informe de clasificación económica y riesgos fiscales",
          "Mapa de flujo de ingresos y su tratamiento tributario",
          "Recomendaciones para la estructura de facturación y contratos"
        ],
        requiredDocs: [
          "Objeto social y estatutos",
          "Contratos comerciales y de fletamento",
          "Estados de cuenta y facturación representativa"
        ],
        icon: "fa-solid fa-briefcase",
        image: global.services + "tax_law/1.webp",
      },
      {
        key: "ubicacion",
        title:
          "Evaluación de la ubicación geográfica y sus implicaciones tributarias (zonas francas / ZEE)",
        summary:
          "Analizamos el impacto fiscal y aduanero según la ubicación operativa (zona franca, ZEE, puerto nacional), identificando incentivos y requisitos.",
        details:
          "Determinamos si la operación puede acogerse a regímenes especiales (Zonas Económicas Especiales / Zonas Francas), las condiciones para acceder a beneficios (exoneraciones de IVA/ISLR, reintegros, depreciación acelerada) y los requisitos formales. Evaluamos también las obligaciones aduaneras asociadas y los beneficios de draw-back o devolución de aranceles.",
        deliverables: [
          "Informe de elegibilidad para ZEE/Zona Franca",
          "Checklist de requisitos para acceso a incentivos",
          "Plan de implementación territorial"
        ],
        requiredDocs: [
          "Dirección fiscal y operativa",
          "Permisos y licencias portuarias",
          "Documentación de importaciones/exportaciones"
        ],
        icon: "fa-solid fa-location-dot",
        image: global.services + "tax_law/2.webp",
      },
      {
        key: "tributos",
        title: "Determinación de tributos directos e indirectos aplicables (IVA, ISLR, INCES, IVSS, etc.)",
        summary:
          "Identificamos y cuantificamos los impuestos y contribuciones parafiscales que afectan la operación empresarial.",
        details:
          "Elaboramos una matriz que relaciona cada línea de ingreso/gasto con su tributo correspondiente: tratamiento de IVA (grava o exenta), reglas para el ISLR (base imponible, retenciones y anticipos), obligaciones frente a INCES (aport es) e IVSS, y otros tributos locales o especiales. Incluye recomendaciones de cumplimiento y optimización dentro del marco legal vigente y registro contable adecuado.",
        deliverables: [
          "Cuadro resumen de tributos aplicables por flujo operativo",
          "Simulación de carga tributaria anual",
          "Procedimiento de cálculo de retenciones y anticipos"
        ],
        requiredDocs: [
          "Declaraciones tributarias recientes",
          "Libros contables y registros de ventas/compras",
          "Contratos y facturas representativas"
        ],
        icon: "fa-solid fa-coins",
        image: global.services + "tax_law/3.webp",
      },
      {
        key: "obligaciones",
        title: "Determinación de obligaciones formales: libros contables, declaraciones y retenciones",
        summary:
          "Auditamos y definimos las obligaciones formales frente al SENIAT y entes relacionados: libros, declaraciones periódicas y retenciones.",
        details:
          "Revisamos cumplimiento de libros y registros exigidos por la normativa, obligaciones de declaración mensual/annua (IVA/ISLR), conciliaciones contables y procedimientos de retención a proveedores y personal. Preparamos plantillas, calendarios y pautas internas para reducir riesgos de multas y sanciones administrativas.",
        deliverables: [
          "Checklist de cumplimiento formal y calendario tributario",
          "Plantillas para libros y reportes (digital/impreso)",
          "Procedimiento de retenciones y soporte para auditoría"
        ],
        requiredDocs: [
          "Libros y registros contables",
          "Comprobantes de retención y soporte documental",
          "Políticas internas de control"
        ],
        icon: "fa-solid fa-file-invoice-dollar",
        image: global.services + "tax_law/4.webp",
      },
      {
        key: "incentivos",
        title: "Aplicación de incentivos fiscales y planeamiento de deducciones y créditos",
        summary:
          "Detectamos incentivos, exoneraciones y deducciones aplicables y diseñamos planes para su aprovechamiento legal.",
        details:
          "Analizamos incentivos disponibles (ZEE, reintegros de ISLR/IVA, depreciación acelerada, incentivos por inversión) y proponemos la documentación y flujos que maximicen deducciones y créditos fiscales. Incluye la preparación de solicitudes de exoneración y seguimiento ante autoridades competentes cuando corresponda.",
        deliverables: [
          "Listado de incentivos aplicables con cálculos estimados",
          "Modelos de solicitud y soporte para exoneraciones",
          "Plan de aprovechamiento fiscal anual"
        ],
        requiredDocs: [
          "Estados financieros",
          "Comprobantes de inversión y gastos deducibles",
          "Certificados de zona o régimen especial (si aplica)"
        ],
        icon: "fa-solid fa-hand-holding-dollar",
        image: global.services + "tax_law/5.webp",
      },
      {
        key: "planificacion",
        title: "Evaluación de estructuras internacionales y estrategias aduaneras",
        summary:
          "Estudiamos la necesidad de estructuras internacionales (holding, subsidiarias) y diseñamos estrategias aduaneras para optimizar costos y cumplimiento.",
        details:
          "Realizamos análisis de planeamiento internacional considerando convenios de doble imposición vigentes y la conveniencia de sociedades intermedias (holding) o subsidiarias. Desarrollamos estrategias aduaneras para importación/exportación (regímenes, despacho simplificado, draw-back) minimizando riesgos y costes logísticos y fiscales, siempre dentro del marco legal aplicable.",
        deliverables: [
          "Evaluación de conveniencia de estructura internacional",
          "Mapa de riesgos fiscales internacionales",
          "Plan aduanero operativo y de cumplimiento"
        ],
        requiredDocs: [
          "Estructura societaria actual",
          "Contratos internacionales y facturación de import/export",
          "Documentación aduanera previa"
        ],
        icon: "fa-solid fa-globe",
        image: global.services + "tax_law/6.webp",
      }
    ],
  },
  ctaText: "Solicitar asesoría fiscal",
  ctaLink: "/contacto?servicio=derecho-tributario",
};
